import { apiClient } from '@/lib/api/client';
export const usersApi = {
    async getUsers(query) {
        const { data } = await apiClient.get('/api/v1/users', { params: query });
        return data;
    },
    async getUser(id) {
        const { data } = await apiClient.get(`/api/v1/users/${id}`);
        return data;
    },
    async createUser(dto) {
        const { data } = await apiClient.post('/api/v1/users', dto);
        return data;
    },
    async updateUser(id, dto) {
        const { data } = await apiClient.patch(`/api/v1/users/${id}`, dto);
        return data;
    },
    async deleteUser(id) {
        await apiClient.delete(`/api/v1/users/${id}`);
    },
};
export const ROLE_LABELS = {
    SUPER_ADMIN: 'Super Admin',
    TENANT_ADMIN: 'Admin',
    COORDINATOR: 'Coordinador',
    GUIDE: 'Guía',
    VIEWER: 'Visor',
};
export const ROLE_BADGE_CLASS = {
    SUPER_ADMIN: 'badge-danger',
    TENANT_ADMIN: 'badge-primary',
    COORDINATOR: 'badge-info',
    GUIDE: 'badge-success',
    VIEWER: 'badge-secondary',
};
//# sourceMappingURL=users.js.map